import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  configApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { backstageAdoptionApiRef } from './api/BackstageAdoptionApi';
import { BackstageAdoptionClient } from './api/BackstageAdoptionClient';

export const backstageAdoptionPlugin = createPlugin({
  id: 'backstage-adoption',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: backstageAdoptionApiRef,
      deps: {
        configApi: configApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ configApi, fetchApi }) =>
        new BackstageAdoptionClient({ configApi, fetchApi }),
    }),
  ],
});

export const BackstageAdoptionPage = backstageAdoptionPlugin.provide(
  createRoutableExtension({
    name: 'BackstageAdoptionPage',
    component: () =>
      import('./components/BackstageAdoptionPage').then(
        m => m.BackstageAdoptionPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
